import axios from 'axios';

const state = {
  items: [],
  coupon: '',
  discount: 0,
  shippingFee: 0,
};

const getters = {
  allItems: state =>state.items
};

const actions = {
  async fetchItems ({ commit}) {
    const data = [];
    commit('setItems', data);
  },
  doIt({commit}) {
    console.log('c');
  },
  removeCart({commit} , data) {
    commit('removeCart', data);
  },
  removeTest({commite}) {
    console.log('test');
  },
  reset({state, commit}) {
    commit('resetState', commit);
  }
};

const mutations = {
  setItems: (state, items) => (state.items = items),
  removeCart: (state, data) => {
    state.items = [];
    state.coupon = '';
    state.discount = 0;
    state.shippingFee = 0
    localStorage.removeItem('cart')
  },
  resetState: (state, data) => {
    state.items = [];
    state.coupon = '';
    state.discount = 0;
    state.shippingFee = 0
    console.log('CART → reset')
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js